import { z } from "zod";
import { NpdCalculationState } from "../npd-calculation-state";
import { npdCalculationResultsDtoSchema } from "./npd-calculation-results.schema";
export const npdSucceededCalculationStatusDtoSchema = z.object({
    state: z.literal(NpdCalculationState.Succeeded),
    results: npdCalculationResultsDtoSchema,
});
